import { useState, useEffect } from "react";

export function useOrientation() {
  const getOrientation = () =>
    window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : "landscape";

  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const handler = () => setOrientation(getOrientation());

    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  return orientation;
}

/*
const orientation = useOrientation();

return (
  <GridContainer $portrait={orientation === "portrait"}>
    ...
  </GridContainer>
);




const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.$portrait ? "1fr" : "repeat(3, 1fr)"};
  gap: 2rem;
  padding: 1rem;
`;


*/
